<template>
  <BookingRequests
    :booking-requests="bookingRequests"
    :adventure-types="adventureTypes"
    :hunt-types="huntTypes"
    :hunt-species-list="huntSpeciesList"
    @updateBooking="updateBookingRequest" />
</template>
<script>
import { mapState, mapActions } from 'vuex';
import store from './_store';
import BookingRequests from './_components/BookingRequests.vue';

export default {
  name: 'BookingRequestsModule',
  components: {
    BookingRequests,
  },
  beforeCreate() {
    this.$store.registerModule('$_bookingRequest', store);
  },
  destroyed() {
    this.$store.unregisterModule('$_bookingRequest');
  },
  data() {
    return {
      adventureTypes: [
        {
          label: 'Big Game Hunting',
          value: 'hunt',
        },
        {
          label: 'Mountain Fishing',
          value: 'fish',
        },
        {
          label: 'Family Getaway',
          value: 'getaway',
        },
        {
          label: 'Remote Horseback',
          value: 'horseback',
        },
      ],
      huntTypes: [
        {
          label: 'Archery',
          value: 'archery',
        },
        {
          label: 'Rifle',
          value: 'rifle',
        },
        {
          label: 'None',
          value: 'none',
        },
      ],
      huntSpeciesList: [
        {
          label: 'Deer',
          value: 'deer',
        },
        {
          label: 'Elk',
          value: 'elk',
        },
        {
          label: 'Bear',
          value: 'bear',
        },
      ],
    };
  },
  computed: {
    ...mapState('$_bookingRequest', {
      bookingRequests: state => state.bookingRequests,
    }),
  },
  created() {
    this.fetchBookingRequests();
  },
  methods: {
    ...mapActions('$_bookingRequest', [
      'fetchBookingRequests',
      'updateBookingRequest',
    ]),
  },
};
</script>
